import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomerInformation from './CustomerInformation';
import { addComment, customerDetailsDone, updateCustomer } from '../../stateManagement/engine/actions/OrderActions';
import _ from 'lodash';
import { goBack, reportCustomerInformationContinueAttempt } from '../../stateManagement/engine/actions/SessionActions';

function mapStateToProps(state, ownProps) {
  return {
    contacts: state.order.callerInfo.contacts || [],
    customer: state.order.customer || {},
    comments: state.order.comments || [],
    user: _.last(state.session.user) || {},
    countryCode: _.get(state, 'session.organization.address.countryCode'),
    locale: _.get(state, 'session.organization.locale'),
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    ...bindActionCreators(
      { updateCustomer, addComment, customerDetailsDone, goBack, reportCustomerInformationContinueAttempt },
      dispatch,
    ),
    ...ownProps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomerInformation);
